import { Tag } from 'antd'
import React from 'react'
import { D4_Lot_Coproprietaire } from '../../types'

const Lots = ({ lots }: { lots: D4_Lot_Coproprietaire[] | undefined }) => {
  return (
    <>
      {lots?.map((copro, i) => (
        <Tag key={i}>
          {copro.lot?.copropriete?.trigramme} - {copro.lot?.batiment?.libelle ?? 'Général'} - {copro.lot?.nature} -{' '}
          {copro.lot?.numerodelot}
        </Tag>
      ))}
    </>
  )
}

export default Lots
